export default "__VITE_ASSET__B9FZ_C6A__"